<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsSwiper',
  
})
</script>
<template>
  <swiper
    :class="['tlbs-swiper', !enablePagination ? 'tlbs-swiper-pagination-hide' : '']"
    v-bind="$attrs"
    :modules="modules"
    :pagination="{ clickable: true }"
    @swiper="initSwiper"
  >
    <slot />
  </swiper>
</template>

<script lang="ts" setup name="TlbsSwiper">
import { Swiper } from 'swiper/vue';
import { Pagination, Autoplay } from 'swiper';
import SwiperClass from 'swiper/types/swiper-class';
import { SwiperModule } from 'swiper/types/shared';
import 'swiper/css';
import 'swiper/css/pagination';
// import 'swiper/css/autoplay';

interface Props {
  enablePagination?: boolean;
  currentIndex?: number;
}

const props = withDefaults(defineProps<Props>(), {
  enablePagination: true,
  currentIndex: 0,
});

const modules: SwiperModule[] = [Pagination, Autoplay];

const swiperComp = ref<null | SwiperClass>(null);
const initSwiper = (swiper: SwiperClass) => {
  swiperComp.value = swiper;
};

watch(() => props.currentIndex, (newVal) => {
  swiperComp.value?.slideTo(newVal);
});

onMounted(() => {
  typeof props.currentIndex === 'number' && swiperComp.value && swiperComp.value.slideTo(props.currentIndex);
});
</script>
